/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */

import Authentication from '../authentication/awsAuthentication';
import API from './awsApi';
import moment from 'moment-timezone';

class JobAPIClass {

    deleteJob(jobId, handler) {
        Authentication.getSession()
        .then(Authentication.getAuthorisation)
        .then((token) => {
            var dataService = API.newClient();

            console.log("[API-JOB] deleting: ", jobId);
            var params = {'jobId' : jobId, "Authorization": token};
            dataService.defaults.headers.common['Authorization'] = token;
            API.handle(dataService.delete('/api/v1/job/' + jobId, params), handler);
        })
        .catch((e) => {
                    console.log("DELETEJOB: ", e.message) ;
                    handler.failure(e);
            }
        );
    }

    getJob(jobId, handler) {
        Authentication.getSession()
        .then(Authentication.getAuthorisation)
        .then((token) => {
            var dataService = API.newClient();

            console.log("[API-JOB] get job: ", jobId);
            var params = {'jobId' : jobId, "Authorization": token};
            dataService.defaults.headers.common['Authorization'] = token;
            API.handle(dataService.get('/api/v1/job/' + jobId, params), handler);
        })
        .catch((e) => handler.failure(e));
    }

    searchJobs(searchText,email,handler) {
        Authentication.getSession()
        .then(Authentication.getAuthorisation)
        .then((token) => {
            var dataService = API.newClient();

            var params = {'searchText' : searchText, 'email' : email, "Authorization": token};
            dataService.defaults.headers.common['Authorization'] = token;
            API.handle(dataService.get('/api/v1/job/search', {params: params}), handler);
        })
        .catch((e) => handler.failure(e));
    }

    getJobHistory(jobnum,handler) {
        Authentication.getSession()
        .then(Authentication.getAuthorisation)
        .then((token) => {
            var dataService = API.newClient();

            var params = {"jobnum" : jobnum, "Authorization": token};
            dataService.defaults.headers.common['Authorization'] = token;
            API.handle(dataService.get('/api/v1/job/history', {params: params}), handler);
        })
        .catch((e) => handler.failure(e));
    }

    getJobHistoryRange(jobId,fromtime,totime,handler) {
        Authentication.getSession()
        .then(Authentication.getAuthorisation)
        .then((token) => {
            var dataService = API.newClient();

            var params = {"jobId" : jobId, "fromtime" : fromtime, "totime" : totime, "Authorization": token};
            dataService.defaults.headers.common['Authorization'] = token;
            API.handle(dataService.get('/api/v1/job/' + jobId + '/historyrange', {params: params}), handler);
        })
        .catch((e) => handler.failure(e));
    }

    getJobHistoryDay(jobId,timestamp,handler) {
        Authentication.getSession()
        .then(Authentication.getAuthorisation)
        .then((token) => {
            var dataService = API.newClient();

            var params = {"jobId" : jobId, "timestamp" : timestamp, "Authorization": token};
            dataService.defaults.headers.common['Authorization'] = token;
            API.handle(dataService.get('/api/v1/job/' + jobId + '/history', {params: params}), handler);
        })
        .catch((e) => handler.failure(e));
    }

    getJobHistorySummary(jobId,handler) {
        Authentication.getSession()
        .then(Authentication.getAuthorisation)
        .then((token) => {
            var dataService = API.newClient();

            let localtz = moment.tz.guess() ;
            var params = {"jobId" : jobId, "Authorization": token};
            dataService.defaults.headers.common['Authorization'] = token;
            API.handle(dataService.get('/api/v1/job/' + jobId + '/status?localtz=' + localtz, {params: params}), handler);
        })
        .catch((e) => handler.failure(e));
    }


    async getJobHistorySummaryV2(jobId) {
        try {
            let session = await Authentication.getSession() ;
            let token = await Authentication.getAuthorisation(session) ;
            let client = API.newClient();
            let params = {"jobId" : jobId, "Authorization": token};
            client.defaults.headers.common['Authorization'] = token;
            return await API.secureGet(client, `/api/v2/jobs?mode=DATES&jobid=${jobId}`, {}) ;
        }
        catch(e){
            console.error("Error retrieving job history summary: ", e) ;
            return null ;
        }
    }

    saveJob(job,handler) {
        Authentication.getSession()
        .then(Authentication.getAuthorisation)
        .then((token) => {
            var dataService = API.newClient();

            var params = { "Authorization": token};
            dataService.defaults.headers.common['Authorization'] = token;
            API.handle(dataService.post('/api/v1/job', job), handler);
        })
        .catch((e) => handler.failure(e));
    }

    attachImageToJob(jobId, imageFile, handler) {

        // There MUST be an easier way than this!!! ApiGateway S3 proxy doesn't work (certainly not binary!)

         var reader = (token) => {
            return new Promise(function(resolve, reject) {
                console.log("IMAGEFILE=", imageFile);
                let reader = new FileReader();
                let file = imageFile;

                const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
                    const byteCharacters = atob(b64Data);
                    const byteArrays = [];

                    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                        const slice = byteCharacters.slice(offset, offset + sliceSize);

                        const byteNumbers = new Array(slice.length);
                        for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                        }

                        const byteArray = new Uint8Array(byteNumbers);

                        byteArrays.push(byteArray);
                    }

                    const blob = new Blob(byteArrays, {type: contentType});
                    return blob;
                }

                reader.onloadend = () => {
                    console.log("[FileAPI] - content loaded");
                    let base64String = btoa([].reduce.call(new Uint8Array(reader.result),function(p,c){return p+String.fromCharCode(c)},''));
                    resolve({content: base64String , token: token});
                }
                reader.onerror = (err) => {
                    console.log("[FileAPI] - content load error: ", err);
                    reject({status: "ERROR", message: "File reader reported an error : ", err});
                }

                reader.readAsArrayBuffer(file);
            }
        )};

        Authentication.getSession()
        .then(Authentication.getAuthorisation)
        .then(reader)
        .then((state) => {
            console.log("CREDENTIALS LOADING: ");
            console.log("[AUTH] - token=", state.token);

            var dataService = API.newClient();
            var params = {"jobId" : jobId, "Authorization": state.token};
            var body = {
                "content-type"  : "image/png",
                "jobId"         : jobId,
                "content"       : state.content
            }
            dataService.defaults.headers.common['Authorization'] = state.token;
            API.handle(dataService.put('/api/v1/job/' + jobId + '/photo', body), handler);
        })
        .catch((e) => handler.failure(e));
    }

}

const JobAPI = new JobAPIClass();
export default JobAPI;





// WEBPACK FOOTER //
// ./src/app/api/awsJobAPI.js